/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { keyframes, css } from 'styled-components';

/**
 * Estilização do componente opacityPulse
 */
export const opacityPulse = keyframes`
 0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

/**
 * Estilização do componente Container
 */
export const Container = styled.div`
  padding: ${({ onlyContent }) => (onlyContent ? '0' : '30px 0')};
  min-width: 300px;

  p,
  h2,
  h3,
  button {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
  }

  button {
    font-size: 16px;
    line-height: 19px;
    color: #3c71dd;
    border: 0;
    padding: 0;
    background: transparent;
    span {
      margin-left: 12px;
    }
  }

  .item {
    width: -webkit-fill-available;
    width: -moz-available;
    p {
      font-size: 12px;
      line-height: 14px;
      color: #5e5e5e;
      margin: 0;

      &.attrValue {
        margin-top: 15px;
      }
    }
  }

  svg.arrow {
    transition: 0.5s transform;
    transform: ${({ isClosed }) => (isClosed ? 'none' : 'rotate(90deg)')};
  }

  hr {
    margin: 35px 0 0 0;
    border-top: 1px solid #e0e0e0;
  }
`;

/**
 * Estilização do componente MetadataTitle
 */
export const MetadataTitle = styled.div`
  margin-top: ${({ onlyContent }) => (onlyContent ? '0' : '33px')};
  max-height: 36px;

  h3 {
    font-size: 16px;
    line-height: 18px;
    color: #5e5e5e;
    overflow-wrap: anywhere;
  }
`;

/**
 * Estilização do componente MetadataDescription
 */
export const MetadataDescription = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  overflow: auto;
  max-height: ${({ descriptionOverflow }) =>
    descriptionOverflow ? descriptionOverflow : 'unset'};

  /* width */
  ::-webkit-scrollbar {
    width: 21px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d8d8d8;
    border-radius: 10px;
    border: 8px solid #fff;

    /* Handle on hover */
    &:hover {
      background: #5d5d5d;
    }
  }

  p {
    font-size: 12px;
    line-height: 17px;
    /* text-indent: 30px; */
    color: #5e5e5e;
  }

  @media (max-width: 768px) {
    max-height: unset;
  }
`;

/**
 * Estilização do componente MetadataAtributes
 */
export const MetadataAtributes = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: space-between;

  > div {
    flex: 1 1 auto;
    position: relative;
    margin: 0 7px;
    padding-right: 14px;

    &:first-child {
      margin-left: 0px;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: -1px;
      height: 30px;
      border-right: 1px solid #d2d1d1;
    }

    &:last-child {
      margin-right: 0px;

      &::after {
        border: none;
      }
    }

    h3 {
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 16px;
      color: #5e5e5e;
    }

    p {
      display: flex;
      font-size: 10px;
      line-height: 12px;
      margin: 0;
      padding: 0;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
  }
`;

/**
 * Estilização do componente PanelWrapper
 */
export const PanelWrapper = styled.div`
  max-height: ${({ maxHeight }) => maxHeight || '0'};
  overflow: hidden;
  transition: max-height 0.2s ease-out;
`;

/**
 * Estilização do componente Skeleton
 */
export const Skeleton = styled.div`
  margin-top: ${({ marginTop }) => marginTop || '15px'};
  background: ${({ color }) => color || '#E6E5E5'};
  border-radius: ${({ borderRadius }) => borderRadius || '2px'};
  height: ${({ height }) => height || '10px'};
  width: ${({ width }) => width || '100%'};
  ${({ loading }) =>
    loading &&
    css`
      animation: ${opacityPulse} 2s ease-in-out infinite;
    `}
`;

/**
 * Estilização do componente MetadataItemWrap
 */
export const MetadataItemWrap = styled.div`
  button {
    font-size: 12px;
    line-height: 14px;
  }

  textarea {
    height: 0;
    width: 0;
    opacity: 0;
    display: block;
  }
`;
